import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import useTimeout from "./useTimeout";
function useInterval(callback, interval) {
  var _useTimeout = useTimeout(function () {
      callback();
      start();
    }, interval),
    _useTimeout2 = _slicedToArray(_useTimeout, 2),
    start = _useTimeout2[0],
    cancel = _useTimeout2[1];
  return [start, cancel];
}
export default useInterval;